export async function checkAuth(): Promise<boolean> {
  // Skip auth check for localhost development
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return true;
  }

  try {
    const response = await fetch('https://login.popmeme.online/api/session', {
      method: 'GET',
      credentials: 'include',
      mode: 'cors',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      if (response.status === 401) {
        window.location.href = 'https://login.popmeme.online/app';
        return false;
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return !!data.session;
  } catch (error) {
    console.error('Auth check failed:', error);
    window.location.href = 'https://login.popmeme.online/app';
    return false;
  }
} 